import { useEffect, useState } from "react";

export const useIsFirstTimeTrue = (isTrue: boolean) => {
  const [isFirstTimeTrue, setIsFirstTimeTrue] = useState<boolean | null>(null);
  useEffect(() => void setIsFirstTimeTrue(isTrue && isFirstTimeTrue === null), [isTrue, isFirstTimeTrue]);
  return [isFirstTimeTrue];
};
